if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let quantityInput = null;

        if (window.innerWidth >= 750) {
          const el = this.closest('.card__content');
          if (el) {
            quantityInput = el.querySelector('.quantity__input');
          }
        } else {
          const el = this.querySelector('.mobile-qty-button');
          if (el) {
            quantityInput = el.querySelector('.quantity__input');
          }
        }

        if (quantityInput) {
          var quantity = quantityInput ? quantityInput.value : 1;
          var formData = new FormData(this.form);
          formData.append('quantity', quantity);
        } else {
          var formData = new FormData(this.form);
        }



        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            setTimeout(() => {
              Rebuy.init()
            }, 1000);

            document.querySelectorAll(".cart-drawer__form .cart-item").forEach(function(item) {

                const quantityInput = item.querySelector(".cart-quantity .quantity__input");
                if (!quantityInput) return;

                const cartqty = quantityInput.getAttribute("data-cart-quantity");
                const cartqtyid = quantityInput.getAttribute("data-quantity-variant-id");

                if (!cartqtyid) return;

                const targetInput = document.querySelector(
                  '#product-grid .grid__item .cart-quantity .quantity__input[data-quantity-variant-id="' + cartqtyid + '"]'
                );

                if (targetInput) {
                  targetInput.setAttribute("data-cart-quantity", cartqty);
                  targetInput.setAttribute("max", cartqty);
                  targetInput.setAttribute("data-max", cartqty);
                  const getcartqty = targetInput.getAttribute("data-cart-quantity");
                  const getmaxproduct = targetInput.getAttribute("data-max-product");
                  const mainelement = targetInput.closest(".card__content");
                  const productForm = mainelement.querySelector("product-form");
                  const quickAddBtn = productForm.querySelector(".quick-add__submit");
                  const qtybuttonPlus = mainelement.querySelector(".quantity__button[name='plus']");
                  if(getcartqty == getmaxproduct){
                      qtybuttonPlus.classList.toggle('disabled', 'true');
                      if (!productForm) return;
                      if (quickAddBtn) {
                        quickAddBtn.setAttribute("disabled", "true");
                      }
                  }else {
                    if (qtybuttonPlus) {
                      qtybuttonPlus.classList.remove("disabled");
                    }

                    if (quickAddBtn) {
                      quickAddBtn.removeAttribute("disabled");
                    }
                  }
                  
                }

              });

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
